import { BodyText, DetailText, Flex } from '@utilitywarehouse/hearth-react';

import { ServiceTile, getServiceTileId } from '@components/ServiceTile';

interface CallPackageTileProps {
  description: string;
  isSelected: boolean;
  price: string;
  serviceName: string;
  testId?: string;
  value: string;
}

const CallPackageTile = ({
  description,
  isSelected,
  price,
  serviceName,
  testId,
  value,
}: CallPackageTileProps) => (
  <ServiceTile
    buttonText="package"
    description={<BodyText color="secondary">{description}</BodyText>}
    gap="lg"
    isSelected={isSelected}
    serviceName={serviceName}
    testId={testId}
    value={value}
  >
    <Flex alignItems="baseline" spacing="sm">
      <DetailText id={getServiceTileId(serviceName, 'price')} size="3xl">
        {price}
      </DetailText>
      <BodyText size="sm" as="span">
        a month
      </BodyText>
    </Flex>
  </ServiceTile>
);

export { CallPackageTile };
